import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { DashboardTable } from '@/components/DashboardTable'
import { DonorChart } from '@/components/DonorChart'

const kpiCards = [
  { title: 'Total Donors',        value: '--' },
  { title: 'Open Opportunities',  value: '--' },
  { title: 'Active Volunteers',   value: '--' },
  { title: 'Documents Filed',     value: '--' },
]

export default function DashboardIndex() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Dashboard</h1>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {kpiCards.map((card) => (
          <Card key={card.title}>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {card.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-2xl font-bold">{card.value}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Table and Chart row */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Recent Activities</CardTitle>
          </CardHeader>
          <CardContent>
            <DashboardTable />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Donor Activity</CardTitle>
          </CardHeader>
          <CardContent>
            <DonorChart />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
